import { Shape } from '@material-ui/core/styles/shape';

export const shape: Shape = {
  borderRadius: 2,
};

export default shape;
